import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/tipos-documento`;

export async function getTiposDocumento() {
  const response = await axios.get(baseUrl);
  return response.data;
}